import {silver} from '~libSass/base/_exports.sass';

export const selectFabricArt = ({fabricDesign}) => fabricDesign.fabricArt;

export const selectFabricArtBackgroundImage = ({fabricDesign}) =>
  fabricDesign.fabricArt?.backgroundImage;

export const selectActiveCardEditor = ({fabricDesign}) => fabricDesign.activeCardEditor;

export const selectEnvelopeStickers = ({fabricDesign}) => fabricDesign.envelopeStickers;

export const selectHasStickersChanged = ({fabricDesign}) =>
  JSON.stringify(fabricDesign?.envelopeStickers || {}) !==
  JSON.stringify(fabricDesign?.init?.envelopeStickers);

export const selectInitEnvelopeStickers = ({fabricDesign}) => fabricDesign.init.envelopeStickers;

export const selectOriginalFabricArt = ({fabricDesign}) => fabricDesign.originalFabricArt;

export const selectBackgroundId = ({fabricDesign}) => fabricDesign.backgroundId;

export const selectHasBackgroundIdChanged = ({fabricDesign}) =>
  fabricDesign.init.backgroundId !== fabricDesign.backgroundId;

export const selectOverlayId = ({fabricDesign}) => fabricDesign.overlayId;

export const selectHasOverlayIdChanged = ({fabricDesign}) =>
  fabricDesign?.init?.overlayId !== fabricDesign?.overlayId;

export const selectRevealId = ({fabricDesign}) => fabricDesign.revealId;

export const selectHasRevealIdChanged = ({fabricDesign}) =>
  fabricDesign?.init?.revealId !== fabricDesign?.revealId;

export const selectBackgroundColor = ({fabricDesign}) => fabricDesign.backgroundColor;

export const selectHasBackgroundChanged = ({fabricDesign}) =>
  fabricDesign.backgroundId !== fabricDesign.init.backgroundId ||
  fabricDesign.backgroundColor !== fabricDesign.init.backgroundColor;

export const selectDefaultBackground = ({fabricDesign}) => fabricDesign.defaultBackground;

export const selectInitBackgroundColor = ({fabricDesign}) => fabricDesign.init.backgroundColor;

export const selectHasBackgroundColorChanged = ({fabricDesign}) =>
  fabricDesign.init.backgroundColor !== fabricDesign.backgroundColor;

export const selectStampId = ({fabricDesign}) => fabricDesign.stampId;

export const selectHasStampIdChanged = ({fabricDesign}) =>
  fabricDesign.init.stampId !== fabricDesign.stampId;

export const selectEnvelopeId = ({fabricDesign}) => fabricDesign.envelopeId || 'wht01';

export const selectHasEnvelopeChanged = ({fabricDesign}) => {
  if (fabricDesign.init) return fabricDesign.init.envelopeId !== fabricDesign.envelopeId;
  return false;
};

export const selectLinerId = ({fabricDesign}) => fabricDesign.linerId;

export const selectHasLinerIdChanged = ({fabricDesign}) => {
  if (fabricDesign.init) return fabricDesign.init.linerId !== fabricDesign.linerId;
  return false;
};

export const selectCurrentSection = ({fabricDesign}) => fabricDesign.currentSection;

export const selectLoaded = ({fabricDesign}) => fabricDesign?.loaded ?? false;

export const selectTouched = ({fabricDesign}) => fabricDesign.touched;

export const selectPristine = ({fabricDesign}) => fabricDesign.pristine;
export const selectPremiumFeaturesWarning = ({fabricDesign}) => fabricDesign.premiumFeaturesWarning;

export const selectIgnorePremiumWarning = ({fabricDesign}) => fabricDesign.ignorePremiumWarning;

export const selectPristineUyo = ({fabricDesign}) => fabricDesign.pristineUyo;

export const selectIsPristineUyo = ({fabricDesign}) => {
  if (typeof fabricDesign.pristineUyo === 'object') {
    return Object.values(fabricDesign.pristineUyo).some((v) => v === true);
  }
  return fabricDesign.pristineUyo;
};

export const selectCountOfUyoImages = ({fabricDesign, eventDetails}) => {
  const objects =
    fabricDesign.originalFabricArt?.objects || eventDetails.fabric_design_data?.objects;
  return objects ? objects.filter((obj) => obj.type === 'uYOImage').length : 0;
};

export const selectPristineBackground = ({fabricDesign}) => fabricDesign.pristineBackground;
export const selectPristineReveal = ({fabricDesign}) => fabricDesign.pristineReveal;
export const selectAllFieldsEdited = ({fabricDesign}) => fabricDesign.allFieldsEdited;

export const selectHasTextbox = ({fabricDesign}) => fabricDesign.hasTextbox;

export const selectPremiumFeaturesPristine = ({fabricDesign}) =>
  fabricDesign.premiumFeaturesPristine;

export const selectSavingStep = ({fabricDesign}) => fabricDesign?.savingStep;

export const selectIsUyo = ({fabricDesign, eventDetails}) => {
  const objects =
    fabricDesign.originalFabricArt?.objects || eventDetails.fabric_design_data?.objects;
  return objects && objects.some((obj) => obj.type === 'uYOImage');
};

export const selectIsFilledUyo = ({fabricDesign, eventDetails}) => {
  const objects = fabricDesign.fabricArt?.objects || eventDetails.fabric_design_data?.objects;
  return objects && objects.some((obj) => obj.type === 'uYOImage' && obj.src);
};

export const selectIsFullDyo = ({fabricTemplate}) =>
  fabricTemplate.templateName.includes('general-full') &&
  fabricTemplate.templateName.includes('dyo');

export const selectTextAreaOpen = ({fabricDesign}) => fabricDesign.textAreaOpen;

export const selectEditingMobile = ({fabricDesign}) => fabricDesign.editingMobile;

export const selectEditorDisabled = ({fabricDesign}) => fabricDesign.editorDisabled;

export const selectEditingUyoMobile = ({fabricDesign}) => fabricDesign.editingUyoMobile;

export const selectRecentTextColors = ({fabricDesign}) => fabricDesign.recentTextColors;

export const selectRecentBackgroundColors = ({fabricDesign}) => fabricDesign.recentBackgroundColors;

export const selectForceShowOnboardingModal = ({fabricDesign}) =>
  fabricDesign.forceShowOnboardingModal;

export const selectShowTextTooltip = ({fabricDesign}) => fabricDesign.showSampleTextTooltip;

export const selectSelectedEnvelope = (state) => {
  const {envelopeId} = state.fabricDesign;
  if (
    !envelopeId ||
    !state?.fabricTemplate?.allEnvelopes ||
    state?.fabricTemplate?.allEnvelopes?.length === 0
  )
    return undefined;
  return (
    state.fabricTemplate.allEnvelopes.find((envelope) => envelope.id === envelopeId) ??
    state.fabricTemplate?.allEnvelopes?.[0]
  );
};

export const selectSelectedStamp = (state) => {
  const {stampId} = state.fabricDesign;
  if (
    !stampId ||
    !state?.fabricTemplate?.allStamps ||
    state?.fabricTemplate?.allStamps?.length === 0
  )
    return undefined;
  return (
    state.fabricTemplate.allStamps.find((stamp) => stamp.id === stampId) ??
    state.fabricTemplate?.allStamps?.[0]
  );
};

export const selectSelectedLiner = (state) => {
  const {linerId} = state.fabricDesign;
  if (!linerId || !state?.fabricTemplate?.allLiners) return undefined;
  return state.fabricTemplate.allLiners.find((liner) => liner.id === linerId);
};

export const selectSelectedBackground = (state) => {
  const {backgroundId} = state.fabricDesign;
  if (!backgroundId || !state?.fabricTemplate?.allBackgrounds) return undefined;
  return state.fabricTemplate.allBackgrounds.find((bg) => bg.id === backgroundId);
};

export const selectAllBackgroundsLoaded = (state) =>
  state.fabricTemplate.allBackgrounds !== undefined;

export const selectSelectedOverlay = (state) => {
  const {overlayId} = state.fabricDesign;
  if (!overlayId || !state?.fabricTemplate?.allOverlays) return undefined;
  return state.fabricTemplate.allOverlays.find((o) => o.id === overlayId);
};
/* eslint-enable consistent-return,no-restricted-syntax */
export const selectSelectedReveal = (state) => {
  const {revealId} = state.fabricDesign;
  if (!revealId || !state?.fabricTemplate?.allReveals) return undefined;
  return state.fabricTemplate.allReveals.find((o) => o.id === revealId);
};

// If free, the original color is always '#E1E3E6' - in premium, original color comes from the template
export const selectBackgroundChanged = (state) => {
  const color = state.fabricDesign.backgroundColor;
  const hasBackgroundImage = state.fabricDesign.backgroundId;
  const originalColor = state.fabricTemplate.premium
    ? state.fabricTemplate.backgroundColor
    : silver;
  return hasBackgroundImage || color !== originalColor;
};

export const selectUsedPremiumFeature = (state) => state.fabricDesign.usedPremiumFeature;
export const selectShouldTogglePremiumBackground = ({fabricDesign}) =>
  fabricDesign.shouldTogglePremiumBackground;

export const selectShouldUseCachedGalleryPhoto = ({fabricDesign}) =>
  fabricDesign.shouldUseCachedGalleryPhoto;
